import { z } from "zod";
export const AvailabilitySlotSchema = z.object({
    startDateTime: z.string(),
    endDateTime: z.string(),
    remainingCapacity: z.number(),
});
export const ServiceAvailabilitySchema = z.object({
    serviceId: z.number(),
    timezone: z.string(),
    slots: z.array(AvailabilitySlotSchema),
});
